export { default } from "./GeniusAssignmentOption";
